import angular from 'angular';

// ES6 modules are implicitly strict, but adding this for JSHint
(function () {
    'use strict';
})();

/**
 * @ngdoc overview
 * @name adminModule.usersServices
 * @description
 * # adminModule.usersServices
 * Module for managing the services of: users. For $http requests, API calls.
 */
const usersServices = angular.module('adminModule.usersServices', []);

/**
 * @ngdoc interface
 * @name adminModule.usersServices.interface:User
 * @description
 * Service for handling Users.
 */
usersServices.factory('User', ['$q', 'UserAPI', 'AppsoupAPI', function ($q, UserAPI, AppsoupAPI) {
    'use strict';

    const prepareUserData = (user, places) => {
        const userData = {
            name: user.name,
            email: user.email,
            password: user.password,
            password_confirmation: user.password_confirmation,
            phone: user.phone,
            description: user.description,
            lang: parseInt(user.lang),
            superadmin: user.superuser,
            bu: user.bu
        };

        if (!user.superuser) {
            angular.extend(userData, {
                role_id: user.role_id,
                client_id: user.client_id,
                app: user.app
            }, AppsoupAPI.preparePlacesTree(places));
        }

        return userData;
    };

    return {
        save: (user, places, editMode) => {
            if (editMode) {
                return UserAPI.editUser(user.id, prepareUserData(user, places));
            } else {
                return UserAPI.newUser(prepareUserData(user, places));
            }
        },
        remove: (id) => {
            return UserAPI.removeUser(id);
        },
        getUser: (id) => {
            return UserAPI.getUser(id);
        },
        getUsers: (params) => {
            const tableParams = AppsoupAPI.getTableParams(params);

            return UserAPI.getUsers(tableParams).then((response) => {
                if (angular.isDefined(response.data.table)) {
                    return response.data.table;
                }
            });
        },
        getClientPermissions: (clientId) => {
            return UserAPI.getClientPermissions(clientId);
        },
        downloadData: (password) => {
            return UserAPI.downloadData(password);
        },
        downloadDataHTML: (password) => {
            return UserAPI.downloadDataHTML(password);
        },
        getBuTypes: (clientId) => {
            return UserAPI.getBuTypes(clientId);
        }
    };
}]);

/**
 * @ngdoc interface
 * @name adminModule.usersServices.interface:UserAPI
 * @description
 * Service for handling API connections for: Users.
 */
usersServices.service('UserAPI', ['$http', 'AppsoupAPI', function ($http, AppsoupAPI) {
    'use strict';

    const API_URL = AppsoupAPI.API_URL + '/user/';

    this.getUsers = (params) => {
        return $http.get(API_URL, {params: params});
    };

    this.getUser = (id) => {
        return $http.get(API_URL + id);
    };

    this.newUser = (user) => {
        return $http.post(API_URL, user);
    };

    this.editUser = (id, user) => {
        return $http.put(API_URL + id, user);
    };

    this.removeUser = (id) => {
        return $http.delete(API_URL + id);
    };

    this.getUserForm = () => {
        return $http.get(API_URL + 'create');
    };

    this.getClientPermissions = (clientId) => {
        return $http.get(API_URL + 'client-permissions/' + clientId);
    };

    this.downloadData = (password) => {
        return $http.post(API_URL + 'export-json', {password: password});
    };

    this.downloadDataHTML = (password) => {
        return $http.post(API_URL + 'export-html', {password: password});
    };

    this.getBuTypes = (clientId) => {
        return $http.get(AppsoupAPI.API_URL + '/client/' + clientId + '/bu-types');
    };
}]);

/**
 * @ngdoc interface
 * @name adminModule.usersServices.interface:UserForm
 * @description
 * Service for handling the form for User page.
 */
usersServices.factory('UserForm', ['UserAPI', 'AppsoupAPI', function (UserAPI, AppsoupAPI) {
    'use strict';

    return {
        getForm: () => {
            return UserAPI.getUserForm();
        },
        fillUserData: (user, permissions) => {
            const userData = {
                id: user.id,
                email: user.email,
                name: user.name,
                phone: user.phone,
                description: user.description,
                lang: String(user.lang),
                superuser: user.superadmin,
                permissions: permissions,
                client_id: user.client_id,
                role_id: user.role_id,
                bu: user.bu
            };
            if (angular.isDefinedNotNull(user.client_admin)) {
                userData.client_admin = user.client_admin;
            }

            return userData;
        },
        getUserPlacePermissions: (permissions) => {
            return AppsoupAPI.convertPlacesTree(permissions);
        }
    };
}]);

export default usersServices;
